<h6>{{ "filter.title" | translate }}</h6>
<div class="container">
  <div class="filter-buttons">
    <button
      *ngFor="let filterObj of filters"
      (click)="applyFilter(filterObj.filter.code)"
      class="filter-button {{ filterObj.icon }} {{
        filterObj.disabled ? 'disabled' : ''
      }}"
      [disabled]="filterObj.disabled"
    >
      <mat-icon>{{ filterObj.icon }}</mat-icon>
    </button>
  </div>

  <filter-form *ngIf="selectedFilterCode"></filter-form>
</div>
